module.exports = __webpack_public_path__ + "img/dentalfit_3_b.3bae16d2.jpg";